var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useEffect, useRef } from 'react';
import styled, { th } from '@xstyled/styled-components';
import { Trans } from '@lingui/react';
import Checkbox from '../../../Forms/Checkbox/Checkbox';
import Toggle from '../../Toggle/Toggle';
import SelectedIndicator from '../components/SelectedIndicator';
var SelectAllWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: 0px 2px 1px 0px;\n  padding: ", ";\n  font-weight: 400;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 6px;\n  height: 36px;\n  cursor: pointer;\n\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  margin: 0px 2px 1px 0px;\n  padding: ", ";\n  font-weight: 400;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 6px;\n  height: 36px;\n  cursor: pointer;\n\n  :hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var additionalPadding = _a.additionalPadding;
    return (additionalPadding ? '8px 27px 8px 10px' : '10px 10px');
}, function (_a) {
    var isSelected = _a.isSelected;
    return (isSelected ? th.color('red20') : 'transparent');
}, function (_a) {
    var isSelected = _a.isSelected;
    return (isSelected ? th.color('red1') : th.color('textPrimary'));
}, function (_a) {
    var isSelected = _a.isSelected;
    return (isSelected ? th.color('red30') : th.color('bgLightGray1'));
});
var SelectAll = function (_a) {
    var onCustomSelectAll = _a.onCustomSelectAll, onCustomDeselectAll = _a.onCustomDeselectAll, value = _a.value, options = _a.options, maxMenuHeight = _a.maxMenuHeight, theme = _a.theme;
    var showCheckbox = !!(theme.optionVariant === 'checkbox');
    var showToggle = !!(theme.optionVariant === 'toggle');
    var ref = useRef(null);
    var _b = useState(false), additionalPadding = _b[0], setAdditionalPadding = _b[1];
    var _c = useState(false), isSelected = _c[0], setIsSelected = _c[1];
    var handleSelectAll = useCallback(function () {
        if (!isSelected) {
            setIsSelected(true);
            onCustomSelectAll();
        }
        else if (isSelected) {
            setIsSelected(false);
            onCustomDeselectAll();
        }
    }, [isSelected, onCustomDeselectAll, onCustomSelectAll]);
    useEffect(function () {
        var _a;
        // if the height of all options is higher than maxMenuHeight and the slider is displayed => the indentation needs to be increased
        ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) && setAdditionalPadding(ref.current.offsetHeight * ((options === null || options === void 0 ? void 0 : options.length) || 0) > maxMenuHeight);
    }, [additionalPadding, maxMenuHeight, options === null || options === void 0 ? void 0 : options.length, value]);
    useEffect(function () {
        if (value && Array.isArray(value)) {
            (options === null || options === void 0 ? void 0 : options.length) === value.length && setIsSelected(true);
            (options === null || options === void 0 ? void 0 : options.length) !== value.length && setIsSelected(false);
        }
    }, [maxMenuHeight, options === null || options === void 0 ? void 0 : options.length, value]);
    return (_jsxs(SelectAllWrap, { isSelected: isSelected, onClick: handleSelectAll, ref: ref, additionalPadding: additionalPadding, children: [(showCheckbox || showToggle) && (_jsxs(SelectedIndicator, { children: [showCheckbox && _jsx(Checkbox, { checked: isSelected, size: 2, readOnly: true }), showToggle && _jsx(Toggle, { name: "", checked: isSelected, spaceAround: false, variant: 'grid' })] })), _jsx(Trans, { id: "datagrid.filterCell.selectAllLabel", message: 'select all' })] }));
};
export default SelectAll;
var templateObject_1;
